// extracted by mini-css-extract-plugin
module.exports = {"root":"Advantages_redesign_root__wR01i","root__transparent":"Advantages_redesign_root__transparent__BbjB_"};